<div>
  <app-aboutdetailpage></app-aboutdetailpage>
  <!-- <app-management></app-management> -->
</div>
